<template>
    <div class="acomodar">
        <SpinnerCarga class="container" v-if="Spinner"/>
        <RenovacionesMasivo v-else />
    </div>
</template>

<script>
import SpinnerCarga from '@/components/ModContratos/Spinner/Spinner.vue'
import RenovacionesMasivo from '@/components/ModContratos/RegRenovacion/RegRenMasiva.vue'
import { mapGetters , mapActions} from "vuex";

export default {
    name: 'SolimanologRenovacionMasiva',
    components:{
        SpinnerCarga , RenovacionesMasivo
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    created(){
        this.cambiarEstadoNavbar()
        this.Renovaciones()
    },
    computed:{
        ...mapGetters('renovaciones',['Spinner'])
    },

    methods: {
        ...mapActions("renovaciones", ["Renovaciones"]),


    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch('acciones/CambioNavbar', true);
    },
    
    }
    
};
</script>

<style scoped>
.acomodar {
    box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  margin-right: 0.5rem !important;
  margin-top: 9px;
  margin-bottom: 9px;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y:hidden;
  }
</style>